import { render } from "./SocialLogin.vue?vue&type=template&id=4818720d&bindings={\"login\":\"options\",\"logout\":\"options\"}"
import script from "./SocialLogin.vue?vue&type=script&lang=js"
export * from "./SocialLogin.vue?vue&type=script&lang=js"
script.render = render

export default script